module.exports = __webpack_public_path__ + "static/media/aspirinQuestion.b86b32f0.mp3";